import { DataSource } from './../../data-sources/sources/abstract-data-source';
import { AbstractDataFilter } from './../filters/abstract-data-filter';
import { DataFiltersLoader } from './../loader/data-filters-loader';
import { DataMerger } from './data-merger';

import _ from 'underscore';

export class DataMergerLogicalOr extends DataMerger {
    constructor(source: DataSource, filters: AbstractDataFilter[], dataFiltersManager: DataFiltersLoader) {
        super(source, filters, dataFiltersManager);
    }

    protected executeInternal() {
        const enabledFilters = this.filters.filter(filter => filter.lastFilterParameters.enabled); // only take into account enabled filters
        if (enabledFilters.length > 0) {
            // efficiency is for later.
            let allFilterDataArrays = enabledFilters.map(filter => filter.filteredData);
            this.filteredData = _.union.apply(_, allFilterDataArrays);
            this.hiddenData = this.source.data.filter((el: any) => {
                return this.filteredData.indexOf(el) < 0;
            });
            this.anyFilterApplied = this.filters.some(filter => filter.anyFilterApplied);
        } else {
            this.filteredData = this.source.data;
            this.hiddenData = [];
            this.anyFilterApplied = false;
        }
    }
}
